import { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import { COMMAND_PALETTE_DEBOUNCE_DEFAULT } from '../../common/constants.tsx';
import { useCommandPaletteSearch } from '../command-palette/index.tsx';

export const useCommandPaletteSearchDebounced = (
	debounceTime: number = COMMAND_PALETTE_DEBOUNCE_DEFAULT,
): [string, (newValue: string) => void] => {
	const [{ search }, { handleSearch }] = useCommandPaletteSearch();

	const [debouncedSearch, setDebouncedSearch] = useState(search);

	const debouncedSetSearch = useMemo(
		() => debounce(setDebouncedSearch, debounceTime),
		[debounceTime],
	);
	useEffect(() => {
		debouncedSetSearch(search);
	}, [debouncedSetSearch, search]);

	useEffect(() => () => debouncedSetSearch.cancel(), [debouncedSetSearch]);

	const setSearch = useCallback(
		(newSearch: string) => {
			debouncedSetSearch.cancel();
			handleSearch(newSearch);
			setDebouncedSearch(newSearch);
		},
		[debouncedSetSearch, handleSearch],
	);

	return useMemo(() => [debouncedSearch, setSearch], [debouncedSearch, setSearch]);
};
